import { FromJsonFn, FromJsonParser } from "../../../../shared/types/parser";

export enum ZoomAuthType {
  Redirect = 'Redirect',
  Device = 'Device',
}

export interface ZoomMetadata {
  authRequired: boolean;
  authUrl: string;
  authHeader: string;
  authType?: ZoomAuthType;
  asteriskEnabled: boolean; // true - Zoom Native (Asterisk), false - Zoom PCA
}

export interface ZoomMetadataParser extends FromJsonParser<ZoomMetadata> { }

// Server returns metadata values as strings ('True' | 'False')
const _toBoolean = (value: unknown): boolean => {
  return String(value).toLowerCase() === 'true';
}

const _fromJson: FromJsonFn<ZoomMetadata> = (json) => {
  return {
    authRequired: _toBoolean(json?.['auth-required']),
    authUrl: json?.['auth-url'],
    authHeader: json?.['auth-header'],
    authType: json?.['auth-type'],
    asteriskEnabled: _toBoolean(json?.['asterisk-enabled']),
  }
}

const _createZoomMetadataParser = (): ZoomMetadataParser => {
  return {
    fromJson: _fromJson,
  }
}

let _parser: ZoomMetadataParser;
export const useZoomMetadataParser = (): ZoomMetadataParser => {
  if (_parser === undefined)
    _parser = _createZoomMetadataParser();

  return _parser;
}
